<template lang="html">
    <div>
        <!-- Groups names -->
        <div class="d-flex justify-content-between my-3 bold">
            <div class="flex-grow-1">{{groupNamesString}}</div>
            <div class="fs-small color-1 pointer normal" @click="toggleExpandInfo">{{expanded? 'hide details':'view details'}}</div>
        </div>

        <div v-if="expanded">
            <!-- General Product Changes -->
            <div v-if="productDetailsHasChanges" class="fs-small bg-lighter p-2">
                <div v-for="editedField in product.changes.details">
                    <span v-html="createNiceString(editedField.niceName, editedField.oldNiceValue, editedField.newNiceValue)"></span>
                </div>
            </div>

            <!-- Product Sales Channels -->
            <div v-if="productSalesChannelsHasChanges" class="fs-small bg-lighter p-2">
                <div v-for="editedField in product.changes.salesChannels">
                    <span v-html="createNiceString(editedField.niceName, editedField.oldNiceValue, editedField.newNiceValue)"></span>
                </div>

                <div v-for="editedField in product.changes.agentSelected">
                    <span v-if="editedField.oldNiceValue != editedField.newNiceValue" v-html="createNiceString(editedField.niceName, editedField.oldNiceValue, editedField.newNiceValue)"></span>
                </div>

                <span v-if="product.changes.agentSelected.length !== 0 && product.changes.agentSelected[0].newNiceValue === 'Agent selection' /* && product.changes.salesChannels.length !== 0 && product.changes.salesChannels[0].newNiceValue != 'Closed' */ ">
                    Note that you have changes in <b>Agent Selection</b> items
                </span>
            </div>

            <!-- Added groups -->
            <div v-if="productHasAddedGroups" class="fs-small bg-lighter p-2">
                <div v-for="editedField in product.changes.addedGroups">
                    <div class="bold">Created group: "{{editedField.newNiceValue}}"</div>
                </div>
            </div>

            <!-- Removed groups -->
            <div v-if="productHasRemovedGroups" class="fs-small bg-lighter p-2">
                <div v-for="editedField in product.changes.removedGroups">
                    <div class="bold">Removed group: "{{editedField.oldNiceValue}}"</div>
                </div>
            </div>

            <div v-if="product.groups.length > 0 && groupHasChanges(group)" v-for="group in product.groups" class="fs-small bg-lighter p-2">
                <!-- Group has id -->
                <div v-if="group.id" >
                    <div class="bold">{{group.label}}:</div>

                    <!-- Changes -->
                    <div class="ml-3">
                        <!-- General  -->
                        <div v-if="groupAreaHasChanges(group)">
                            <div class="bold">Group:</div>

                            <div class="ml-2" v-for="editedField in group.editedFields">
                                <span v-html="createNiceString(editedField.niceName, editedField.oldNiceValue, editedField.newNiceValue)"></span>
                            </div>
                        </div>

                        <!-- Schedule  -->
                        <div v-if="schedulesAreaHasChanges(group)">
                            <div class="bold">Schedule:</div>

                            <div class="ml-2" v-for="editedField in group.editedFieldsSchedules">
                                <div v-for="changes in editedField.changes" v-if="changes.name != 'repeatsAtWeekDays'">
                                    <span v-html="createNiceString(changes.niceName, changes.oldNiceValue, changes.newNiceValue)"></span>
                                </div>
                            </div>

                            <!-- Removed schedules: -->
                            <div v-if="group.editedFieldsSchedulesRemoved" v-for="removedSchedule in group.editedFieldsSchedulesRemoved">
                                <span v-html="'Removed schedule that started at: <b>'+removedSchedule.niceName+'</b>'"></span>
                            </div>

                            <!-- Added schedules: -->
                            <div v-if="group.editedFieldsSchedulesAdded" v-for="addedSchedule in group.editedFieldsSchedulesAdded">
                                <span v-html="'Added new schedule that starts at: <b>'+addedSchedule.niceName+'</b>'"></span>
                            </div>

                        </div>

                        <!-- Gender Prices  -->
                        <div v-if="genderpricesAreaHasChanges(group)">
                            <div class="bold">Prices:</div>
                            <div class="ml-2" v-for="editedField in group.editedFieldsGenderPrice">
                                <div class="horizontalLineTitle bold" v-if="editedField.genderPriceLabel">{{editedField.genderPriceLabel}}</div>

                                <div class="ml-2" v-for="changes in editedField.changes">
                                    <span v-html="createNiceString(changes.niceName, changes.oldNiceValue, changes.newNiceValue)"></span>
                                </div>
                            </div>

                            <!-- Removed gender prices: -->
                            <div class="ml-2" v-if="group.editedFieldsGenderPriceRemoved" v-for="removedGenderPrice in group.editedFieldsGenderPriceRemoved">
                                <div class="horizontalLineTitle bold" v-if="removedGenderPrice.genderPriceLabel">{{removedGenderPrice.genderPriceLabel}}</div>

                                <span class="ml-2" v-html="'Removed price audience: <b>'+removedGenderPrice.niceName+'</b>'"></span>
                            </div>

                            <!-- Added gender prices: -->
                            <div class="ml-2" v-if="group.editedFieldsGenderPriceAdded" v-for="addedGenderPrice in group.editedFieldsGenderPriceAdded">
                                <div class="horizontalLineTitle bold" v-if="addedGenderPrice.genderPriceLabel">{{addedGenderPrice.genderPriceLabel}}</div>

                                <span class="ml-2">
                                    Added new price audience: 
                                    <b> 
                                        {{addedGenderPrice.niceName}} 
                                        <span v-if="addedGenderPrice.item.audienceTypeGroup != null || addedGenderPrice.item.audienceTypeGroup != undefined"> / ( Price Group Name: {{addedGenderPrice.item.audienceTypeGroup}} )</span>
                                    </b>
                                </span>
                            </div>
                        </div>

                         <!-- Gender Price services  -->
                        <div v-if="genderPricesServicesHasChanges(group)">
                            <div class="bold">Prices:</div>

                            <div class="ml-2" v-for="editedField in group.editedFieldsGenderPriceServices">
                                <div class="horizontalLineTitle bold" v-if="editedField.genderPriceLabel">{{editedField.genderPriceLabel}}</div>
                                <div class="ml-2" v-for="changes in editedField.changes">
                                    <span v-html="createNiceString(changes.niceName, changes.oldNiceValue, changes.newNiceValue)"></span>
                                </div>
                            </div>
                        </div>

                        <!-- Rules  -->
                        <div v-if="rulesAreaHasChanges(group)">
                            <div class="bold my-1">Rules:</div>

                            <!-- Removed rule group: -->
                            <div class="ml-2" v-if="group.editedFieldsPriceGroupsRemoved" v-for="removedPriceGroup in group.editedFieldsPriceGroupsRemoved">
                                <span class="ml-2" v-html="'Removed rule group: <b>'+removedPriceGroup.niceName+'</b>'"></span>
                            </div>

                            <!-- Added rule group: -->
                            <div class="ml-2" v-if="group.editedFieldsPriceGroupsAdded" v-for="addedPriceGroup in group.editedFieldsPriceGroupsAdded">
                                <span class="ml-2" v-html="'Added rule group: <b>'+addedPriceGroup.niceName+'</b>'"></span>
                            </div>
                        </div>

                        <!-- Category Dependencies  -->
                        <div v-if="priceDependenciesHasChanges(group)">
                            <div class="bold my-1">Prices Dependencies:</div>

                            <div v-for="deps in group.editedFieldsPriceDependencies">
                                <div class="horizontalLineTitle bold">{{deps.genderPriceLabel}}</div>

                                <div v-for="information in deps.infoToShow">
                                    <!-- Added category dependency -->
                                    <div class="ml-2" v-if="information.type === 'add'">
                                        <span class="ml-2" v-html="`Added category dependency: <b>${information.info}</b>`"></span>
                                    </div>

                                    <!-- Removed category dependency -->
                                    <div class="ml-2" v-if="information.type === 'remove'">
                                        <span class="ml-2" v-html="`Removed category dependency: <b>${information.info}</b>`"></span>
                                    </div>

                                    <!-- Changed category dependency -->
                                    <div class="ml-2" v-if="information.type === 'type'">
                                        <span v-if="information.info.old !== null" class="ml-2" v-html="`Changed dependency type from <b>${information.info.old}</b> to <b>${information.info.new}</b>`"></span>
                                        
                                        <span v-else  class="ml-2" v-html="`New dependency type: <b>${information.info.new}</b>`"></span>
                                    </div>

                                    <!-- Changed quantity dependency -->
                                    <div class="ml-2" v-if="information.type === 'quantity'">
                                        <span class="ml-2" v-html="`<b>${information.info.label}</b> quantity changed from <b>${information.info.oldQuantity}</b> to <b>${information.info.newQuantity}</b>`"></span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- resources  -->
                        <div v-if="resourcesAreaHasChanges(group)">
                            <div class="bold">Resources:</div>
                            <div class="ml-2" v-for="editedField in group.editedFieldsResources">
                                <div v-for="changes in editedField.changes">
                                    <span v-html="createNiceString(changes.niceName, changes.oldNiceValue, changes.newNiceValue)"></span>
                                </div>
                            </div>

                            <!-- Removed schedules: -->
                            <div v-if="group.editedFieldsResourcesRemoved" v-for="removedResource in group.editedFieldsResourcesRemoved">
                                <span v-html="'Removed resource: <b>'+removedResource.niceName+'</b>'"></span>
                            </div>

                            <!-- Added schedules: -->
                            <div v-if="group.editedFieldsResourcesAdded" v-for="addedResource in group.editedFieldsResourcesAdded">
                                <span v-html="'Added new resource: <b>'+addedResource.niceName+'</b>'"></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        product: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            expanded: false
        }
    },
    computed:{
        productDetailsHasChanges() {
            return this.product.changes && this.product.changes.details && this.product.changes.details.length > 0;
        },
        productHasAddedGroups() {
            return this.product.changes && this.product.changes.addedGroups && this.product.changes.addedGroups.length > 0;
        },
        productHasRemovedGroups() {
            return this.product.changes && this.product.changes.removedGroups && this.product.changes.removedGroups.length > 0;
        },
        productSalesChannelsHasChanges() {
            return this.product.changes && this.product.changes.salesChannels && this.product.changes.salesChannels.length > 0 || this.product.changes && this.product.changes.salesPermissionsAgentsList && this.product.changes.salesPermissionsAgentsList.length >= 0;
        },
        groupsWithChanges() {
            return this.product.groups.filter(group => {return this.groupHasChanges(group)});
        },
        groupNamesString() {
            let output = [];

            // Add "Details" if there is a change there
            if (this.productDetailsHasChanges) {
                output.push('Details');
            }

            // Add "Sales Channels" if there is a change there
            if (this.productSalesChannelsHasChanges) {
                output.push('Sales Channels');
            }

            // Add "Groups" if there any added or removed groups
            if (this.productHasRemovedGroups) {
                output.push('Group removed');
            }

            let groupChanges = this.groupsWithChanges.map(g => {return g.label});
            if (groupChanges.length > 0) {
                output.push(groupChanges);
            }

            return output.join(', ');
        }
    },
    methods: {
        toggleExpandInfo() {
            this.expanded = !this.expanded;
        },
        priceDependenciesHasChanges(group) {
            return group.editedFieldsPriceDependencies && group.editedFieldsPriceDependencies.length > 0;
        },
        rulesAreaHasChanges(group) {
            return group.editedFieldsPriceGroupsAdded && group.editedFieldsPriceGroupsAdded.length > 0 
                   || group.editedFieldsPriceGroupsRemoved && group.editedFieldsPriceGroupsRemoved.length > 0;
        },
        groupAreaHasChanges(group) {
            if (!group.editedFields || group.editedFields == null) {
                return false;
            }

            return group.editedFields && group.editedFields.length > 0 ? true : false;
        },
        genderpricesAreaHasChanges(group) {
            if (group.editedFieldsGenderPriceAdded && group.editedFieldsGenderPriceAdded.length > 0 || group.editedFieldsGenderPriceRemoved && group.editedFieldsGenderPriceRemoved.length > 0) {
                return true;
            }

            return group.editedFieldsGenderPrice && group.editedFieldsGenderPrice.filter(editedField => {return editedField.changes.length}).length > 0? true : false;
        },
        genderPricesServicesHasChanges(group) {
            if (group.editedFieldsGenderPriceServices && group.editedFieldsGenderPriceServices.length > 0) {
                return true;
            }

            return false;
        },
        resourcesAreaHasChanges(group) {
            if (group.editedFieldsResourcesAdded && group.editedFieldsResourcesAdded.length > 0 || group.editedFieldsResourcesRemoved && group.editedFieldsResourcesRemoved.length > 0) {
                return true;
            }

            return group.editedFieldsResources && group.editedFieldsResources.filter(editedField => {return editedField.changes.length}).length > 0? true : false;
        },
        schedulesAreaHasChanges(group) {
            if (group.editedFieldsSchedulesAdded && group.editedFieldsSchedulesAdded.length > 0 || group.editedFieldsSchedulesRemoved && group.editedFieldsSchedulesRemoved.length > 0) {
                return true;
            }

            if (!group.editedFieldsSchedules || group.editedFieldsSchedules == null) {
                return false;
            }

            return group.editedFieldsSchedules && group.editedFieldsSchedules.filter(editedField => {return editedField.changes.length}).length > 0? true : false;
        },
        groupHasChanges(group) {
            if (group.id == null) {
                return false;
            }

            return (
                this.groupAreaHasChanges(group) === true ||
                this.genderpricesAreaHasChanges(group) === true ||
                this.resourcesAreaHasChanges(group) === true ||
                this.schedulesAreaHasChanges(group) === true ||
                this.rulesAreaHasChanges(group) === true ||
                this.genderPricesServicesHasChanges(group) === true ||
                this.priceDependenciesHasChanges(group) === true
            )
        },
        createNiceString(niceName, oldValue, newValue) {
            if (oldValue == null || oldValue == '') {
                return niceName + ': <b>'+ newValue +' </b>';
            } else {
                return niceName + ' changed from <b>'+ oldValue+ '</b> to <b>'+ newValue +' </b>';
            }
        },
        createNiceStringOfAgentsSelected(newNiceValue) {
            return newNiceValue;
        }
    }
}
</script>

<style lang="css" scoped>
    .rule-border {
        border-bottom: solid 1px #4b536b;
    }
</style>



// WEBPACK FOOTER //
// scheduleGroupChanges.vue?1643e49c